/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsScrollImages = {
  init: function ($section) {
    const $scrollSlider = $section.find('.has_scroll_slider');
    const $customDots = $section.find('.flickity-custom-dot .dots-m');

    $scrollSlider.flickity({
      wrapAround: true,        
      pageDots: false,
      prevNextButtons: false,
      adaptiveHeight: true,
      watchCSS: true
    });

    function updateActiveDot(index) {
      $customDots.removeClass('is-active');
      $customDots.filter('[data-index="' + index + '"]').addClass('is-active');
    }

    $(document).ready(function() {
      $customDots.on('click', function() {
        const index = $(this).data('index');
        $scrollSlider.flickity('select', index);
        updateActiveDot(index);
      });

      $scrollSlider.on('change.flickity', function(event, index) {
        updateActiveDot(index);
      });
    });

    $scrollSlider.on('settle.flickity', function () {
      $scrollSlider.flickity('resize');
    });
    
  },
  unload: function ($section) {}
};
/******/ })();
